import { useCallback } from "react";

import { toast } from "react-toastify";

import { useAuth } from "../contexts/AuthContext";

const formatAction = (actionName) =>
  typeof actionName === "string" && actionName.trim()
    ? actionName.trim()
    : "This action";

const buildBlockedMessage = (actionName, impersonatingUser) => {
  const customerLabel = impersonatingUser?.email
    ? ` ${impersonatingUser.email}`
    : "";

  return `${formatAction(
    actionName
  )} is disabled while impersonating${customerLabel}. Return to Admin first.`;
};

const useImpersonationGuard = () => {
  const { isImpersonating, impersonatingUser } = useAuth();

  const guardImpersonatedAction = useCallback(
    (actionName) => {
      if (!isImpersonating) return false;

      toast.warning(buildBlockedMessage(actionName, impersonatingUser));

      return true;
    },
    [impersonatingUser, isImpersonating]
  );

  return {
    guardImpersonatedAction,
    isImpersonating,
  };
};

export default useImpersonationGuard;
